<template>
    <div>
        <div>
            <h3>แก้ไขเวลาการทำงาน</h3>
            <br/>
            <b-row sm="10">
                <b-col sm="4" class="col text-right">
                    <label>พนักงาน</label>
                </b-col>
                <b-col sm="6">
                    <input v-model="form.employee"
                           type="text" class="form-control" disabled/>
                </b-col>
            </b-row>
            <br/>
            <b-row sm="10">
                <b-col sm="4" class="col text-right">
                    <label>วัน/เวลาเข้างาน</label>
                </b-col>
                <b-col sm="6">
                    <date-picker
                        v-model="form.time_scan"
                        type="datetime"
                        :lang="lang"
                        format="DD-MM-YYYY hh:mm:ss"
                        placeholder="วันที่ เวลา"
                        confirm>
                    </date-picker>

                </b-col>
            </b-row>
            <br/>
        </div>
        <div class="col text-center">
            <button @click="submitData"
                    type="button"
                    class="btn btn-success">
                <icon name="save" style="width: 25px"></icon>
                บันทึก
            </button>&nbsp;&nbsp;
            <button @click="cancelData"
                    type="button"
                    class="btn btn-outline-secondary">
                <icon name="times" style="width: 25px"></icon>
                ยกเลิก
            </button>
        </div>
        <!--                <pre class="alert-primary">{{form}}</pre>-->
    </div>
</template>

<script>
import {mapState} from "vuex";
import Multiselect from "vue-multiselect";
import DatePicker from 'vue2-datepicker';
import moment from "moment";

export default {
    name: "edit-work-time-modal",
    created() {

    },
    data() {
        return {
            changeFormat: {
                stringify: (date) => {
                    let date_moment = moment(date).format('YYYY');
                    const year = parseInt(date_moment) + 543;
                    //console.log(moment(date).format('DD/MM/'+year));
                    return date ? moment(date).format('DD/MM/' + year) : null
                },
                parse: (value) => {
                    return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                }
            },
            lang: {
                days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                placeholder: {
                    date: 'วว/ดด/ปปปป',
                }
            },
        }
    },
    components: {
        Multiselect,
        DatePicker,
    },
    computed: {
        ...mapState({
            form: (state) => {
                return state.ScanEmployee.form;
            },
        })

    },
    methods: {
        submitData() {
            if (!this.form.time_scan) {
                alert('กรุณาเลือกวัน/เวลาเข้างาน')
            } else {

                if (this.form.time_scan) {
                    this.form.time_scan = moment(this.form.time_scan).format("YYYY-MM-DD HH:mm:ss");
                } else {
                    this.form.time_scan = "";
                }
                this.$emit("submit", this.form);
            }
        },
        cancelData() {
            this.$emit("submit", 0);
        }
    }
}
</script>

<style scoped>

</style>
